import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Card, Container, Row, Col, Form, FormLabel, Accordion, InputGroup } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import Select from 'react-select';



export default function DGTH_pdc({ entity, data, setData, searchObj, setSearchObj }) {

    const familyRef = useRef(null);
    const warehouseRef = useRef(null);
    const brandRef = useRef(null);
    const incotermsRef = useRef(null);
    const paymentRef = useRef(null);
    const countryRef = useRef(null);
    const agentRef = useRef(null);
    const salesRef = useRef(null);

    const navigate = useNavigate();
    const [incotermsList, setIncotermsList] = useState([]);
    const [incoterms, setIncoterms] = useState([]);
    const [paymentList, setPaymentList] = useState([]);
    const [payment, setPayment] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [country, setCountry] = useState([]);
    const [agentList, setAgentList] = useState([]);
    const [agent, setAgent] = useState([]);
    const [brandList, setBrandList] = useState([]);
    const [brand, setBrand] = useState([]);
    const [warehouseList, setWarehouseList] = useState([]);
    const [warehouse, setWarehouse] = useState([]);
    const [familyList, setFamilyList] = useState([]);
    const [family, setFamily] = useState([]);
    const [salesGroupList, setSalesGroupList] = useState([]);
    const [salesGroup, setSalesGroup] = useState([]);

    const [customer, setCustomer] = useState("");
    const [order, setOrder] = useState("");
    const [codeItem, setCodeItem] = useState("");
    const [nameItem, setNameItem] = useState("");
    const [dateOrderFrom, setDateOrderFrom] = useState("");
    const [dateOrderTo, setDateOrderTo] = useState("");
    const [dateDeliveryFrom, setDateDeliveryFrom] = useState("");
    const [dateDeliveryTo, setDateDeliveryTo] = useState("");
    const [righe, setRighe] = useState("");
    const [bindella, setBindella] = useState("");
    const [pdc, setPdc] = useState("");


    const [quantity, setQuantity] = useState(null);
    const [packages, setPackages] = useState(null);
    const [weight, setWeight] = useState(null);
    const [volume, setVolume] = useState(null);
    const [totalPrice, setTotalPrice] = useState(null);
    const [totalPriceNoDisp, setTotalPriceNoDisp] = useState(null);
    const [totalOrder, setTotalOrder] = useState(null);
    const [totalOrderDisp, setTotalOrderDisp] = useState(null);
    const [totalOrderNoDisp, setTotalOrderNoDisp] = useState(null);


    const colourStyles = {
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            const color = "#1C3550";
            return {
                ...styles,
                backgroundColor: isSelected
                    ? color
                    : isFocused
                        ? "#1c35504d"
                        : undefined,
                color: isSelected
                    ? "white"
                    : "black",
                ':active': {
                    ...styles[':active'],
                    backgroundColor: isSelected
                        ? color
                        : "#1c35504d"

                },
            };
        }
    };


    useEffect(() => {
        getIncoterms();
        getPaymentGroup();
        getCountry();
        getAgent();
        getBrand();
        getWarehouse();
        getFamily();
        getSalesGroup();
    }, []);

    const [totalsComputed, setTotalsComputed] = useState(false);

    function computeTotals() {
        if (!Array.isArray(data)) return;
        setQuantity(data.reduce((acc, cur) => acc + (Number(cur.quantity) || 0), 0));
        setPackages(data.reduce((acc, cur) => acc + (parseFloat(cur.packages) || 0), 0));
        setWeight(data.reduce((acc, cur) => acc + (parseFloat(cur.grossWeight) || 0), 0));
        setVolume(data.reduce((acc, cur) => acc + (parseFloat(cur.volume) || 0), 0));
        const td = data.reduce((accumulator, currentItem) => {
            if (currentItem.badge === 1) {
                const price = parseFloat(currentItem.total_price);
                if (!isNaN(price)) {
                    return accumulator + price;
                }
            }
            return accumulator;
        }, 0);
        setTotalPrice(td);
        const tnd = data.reduce((accumulator, currentItem) => {
            if (currentItem.badge !== 1) {
                const price = parseFloat(currentItem.total_price);
                if (!isNaN(price)) {
                    return accumulator + price;
                }
            }
            return accumulator;
        }, 0);
        setTotalPriceNoDisp(tnd);
        const unique = Array.from(new Map(data.map(item => [item.id_order, item])).values());
        setTotalOrder(unique.reduce((acc, cur) => acc + (parseFloat(cur.total_order) || 0), 0));
        const tond = unique.reduce((accumulator, currentItem) => {
            if (currentItem.badge !== 1) {
                const price = parseFloat(currentItem.total_order);
                if (!isNaN(price)) {
                    return accumulator + price;
                }
            }
            return accumulator;
        }, 0);
        const tod = unique.reduce((accumulator, currentItem) => {
            if (currentItem.badge === 1) {
                const price = parseFloat(currentItem.total_order);
                if (!isNaN(price)) {
                    return accumulator + price;
                }
            }
            return accumulator;
        }, 0);
        setTotalOrderDisp(tod);
        setTotalOrderNoDisp(tond);
        setTotalsComputed(true);
    }

    // Reset totals when filters/data change; compute only on user action
    useEffect(() => {
        setTotalsComputed(false);
        setQuantity(null);
        setPackages(null);
        setWeight(null);
        setVolume(null);
        setTotalPrice(null);
        setTotalPriceNoDisp(null);
        setTotalOrder(null);
        setTotalOrderDisp(null);
        setTotalOrderNoDisp(null);
    }, [searchObj, data]);

    async function getIncoterms() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var res = await DataManager.getItemsSimple('incoterms', 1, 500, sorting);
        if (res.success === 1) {
            const temp = res.body.map(item => ({ value: item.id, label: item.name }));
            setIncotermsList(temp)
        }

    }
    async function getPaymentGroup() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var res = await DataManager.getItemsSimple('payment_condition_group', 1, 500, sorting);
        if (res.success === 1) {
            const temp = res.body.map(item => ({ value: item.id, label: item.name }));
            setPaymentList(temp)
        }

    }
    async function getCountry() {
        var sorting = {
            'field': 'name',
            'order': 'asc'
        }
        var res = await DataManager.getItemsSimple('country', 1, 500, sorting);
        if (res.success === 1) {
            const temp = res.body.map(item => ({ value: item.id, label: item.name }));
            setCountryList(temp)
        }
    }
    async function getAgent() {
        var sorting = {
            'field': 'name',
            'order': 'asc'
        }
        var res = await DataManager.getItemsSimple('sales_agent', 1, 500, sorting);
        if (res.success === 1) {
            const temp = res.body.map(item => ({ value: item.id, label: item.name }));
            setAgentList(temp)
        }
    }
    async function getBrand() {
        var sorting = {
            'field': 'name',
            'order': 'asc'
        }
        var res = await DataManager.getItemsSimple('brand', 1, 500, sorting);
        if (res.success === 1) {
            const temp = res.body.map(item => ({ value: item.id, label: item.name }));
            setBrandList(temp)
        }
    }
    async function getWarehouse() {
        var sorting = {
            'field': 'name',
            'order': 'asc'
        }
        var res = await DataManager.getItemsSimple('warehouse', 1, 500, sorting);
        if (res.success === 1) {
            const temp = res.body.map(item => ({ value: item.id, label: item.name }));
            setWarehouseList(temp)
        }
    }
    async function getFamily() {
        var sorting = {
            'field': 'name',
            'order': 'asc'
        }
        var res = await DataManager.getItemsSimple('item_model_family', 1, 500, sorting);
        if (res.success === 1) {
            const temp = res.body.map(item => ({ value: item.id, label: item.name }));
            setFamilyList(temp)
        }
    }
    async function getSalesGroup() {
        var sorting = {
            'field': 'name',
            'order': 'asc'
        }
        var res = await DataManager.getItemsSimple('item_model_sales_group', 1, 500, sorting);
        if (res.success === 1) {
            const temp = res.body.map(item => ({ value: item.id, label: item.name }));
            setSalesGroupList(temp)
        }
    }


    function handleIncoterms(option, actionMeta) {
        if (actionMeta.action == "clear") {
            setIncoterms([]);
        }
        else {
            const temp = [];
            for (let i = 0; i < option.length; i++) {
                temp.push(option[i].label)
            }
            setIncoterms(temp);
        }
    }
    function handleCountry(option, actionMeta) {
        if (actionMeta.action == "clear") {
            setCountry([]);
        }
        else {
            const temp = [];
            for (let i = 0; i < option.length; i++) {
                temp.push(option[i].value)
            }
            setCountry(temp);
        }
    }
    function handleAgenti(option, actionMeta) {
        if (actionMeta.action == "clear") {
            setAgent([]);
        }
        else {
            const temp = [];
            for (let i = 0; i < option.length; i++) {
                temp.push(option[i].label)
            }
            setAgent(temp);
        }
    }
    function handleBrand(option, actionMeta) {
        if (actionMeta.action == "clear") {
            setBrand([]);
        }
        else {
            const temp = [];
            for (let i = 0; i < option.length; i++) {
                temp.push(option[i].value)
            }
            setBrand(temp);
        }
    }
    function handlePayment(option, actionMeta) {
        if (actionMeta.action == "clear") {
            setPayment([]);
        }
        else {
            const temp = [];
            for (let i = 0; i < option.length; i++) {
                temp.push(option[i].value)
            }
            setPayment(temp);
        }
    }
    function handleWarehouse(option, actionMeta) {
        if (actionMeta.action == "clear") {
            setWarehouse([]);
        }
        else {
            const temp = [];
            for (let i = 0; i < option.length; i++) {
                temp.push(option[i].value)
            }
            setWarehouse(temp);
        }
    }
    function handleFamily(option, actionMeta) {
        console.log(option)
        if (actionMeta.action == "clear") {
            setFamily([]);
        }
        else {
            const temp = [];
            for (let i = 0; i < option.length; i++) {
                temp.push(option[i].value)
            }
            setFamily(temp);
        }
    }
    function handleSalesGroup(option, actionMeta) {
        if (actionMeta.action == "clear") {
            setSalesGroup([]);
        }
        else {
            const temp = [];
            for (let i = 0; i < option.length; i++) {
                temp.push(option[i].value)
            }
            setSalesGroup(temp);
            console.log(temp)
        }
    }

    function Filter() {
        console.log(righe)
        var c = [];
        if (incoterms.length > 0) {
            c.push({ fieldName: "incoterms", type: "in", value: incoterms.toString() })
        }
        if (payment.length > 0) {
            c.push({ fieldName: "id_payment_condition_group", type: "in", value: payment.toString() })
        }
        if (country.length > 0) {
            c.push({ fieldName: "country", type: "in", value: country.toString() })
        }
        if (salesGroup.length > 0) {
            c.push({ fieldName: "sales_group", type: "in", value: salesGroup.toString() })
        }
        if (agent.length > 0) {
            c.push({ fieldName: "agent", type: "in", value: agent.toString() })
        }
        if (brand.length > 0) {
            c.push({ fieldName: "id_catalog", type: "in", value: brand.toString() })
        }
        if (family.length > 0) {
            c.push({ fieldName: "id_family", type: "in", value: family.toString() })
        }
        if (warehouse.length > 0) {
            c.push({ fieldName: "idWarehouse", type: "in", value: warehouse.toString() })
        }
        if (customer !== "") {
            c.push({ fieldName: "customer_name", type: "like", value: customer })
        }
        if (order !== "") {
            c.push({ fieldName: "riferimento", type: "like", value: order })
        }
        if (codeItem !== "") {
            c.push({ fieldName: "item_code", type: "like", value: codeItem })
        }
        if (nameItem !== "") {
            c.push({ fieldName: "item_name", type: "like", value: nameItem })
        }
        if (dateOrderFrom !== "") {
            c.push({ fieldName: "dateOrder", type: "greater", value: dateOrderFrom })
        }
        if (dateOrderTo !== "") {
            c.push({ fieldName: "dateOrder", type: "minor", value: dateOrderTo })
        }
        if (dateDeliveryFrom !== "") {
            c.push({ fieldName: "deliveryDate", type: "greater", value: dateDeliveryFrom })
        }
        if (dateDeliveryTo !== "") {
            c.push({ fieldName: "deliveryDate", type: "minor", value: dateDeliveryTo })
        }
        if (righe !== "") {
            if (parseInt(righe) === 1) {
                c.push({ fieldName: "badge", type: "value", value: 1 })
            } else {
                c.push({ fieldName: "badge", type: "different_from_value", value: 1 })
            }

        } else {
            c = c.filter(item => !(item.fieldName === "badge"));
        }
        if (bindella !== "") {
            c.push({ fieldName: "bindella", type: "value", value: parseInt(bindella) })
        } else {
            c = c.filter(item => !(item.fieldName === "bindella"));
        }
        if (pdc !== "") {
            if (pdc === "1") {
                c.push({ fieldName: "idShippingPlan", type: "different_from_value", value: 0 })

            } else if (pdc === "0") {
                c.push({ fieldName: "idShippingPlan", type: "value", value: 0})
            }
        } else {
            c = c.filter(item => !(item.fieldName === "idShippingPlan"));
        }
        console.log(c)
        setSearchObj({
            'query': '',
            'fields': [],
            'constraints': c
        })
    }
    function reset() {
        setCustomer("");
        setOrder("");
        setNameItem("");
        setCodeItem("");
        setDateOrderFrom("");
        setDateOrderTo("");
        setDateDeliveryFrom("");
        setDateDeliveryTo("");
        setRighe("");
        setBindella("");
        familyRef.current.clearValue();
        warehouseRef.current.clearValue();
        brandRef.current.clearValue();
        incotermsRef.current.clearValue();
        paymentRef.current.clearValue();
        countryRef.current.clearValue();
        agentRef.current.clearValue();
        salesRef.current.clearValue();
        setSearchObj({
            'query': '',
            'fields': [],
            'constraints': []
        })
    }



    return (
        <>
            <Container fluid className='mb-2 mt-3'>
                <Accordion defaultActiveKey={['0']} alwaysOpen>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Filtri</Accordion.Header>
                        <Accordion.Body>
                            <Row className='align-items-start mb-2'>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Cliente</FormLabel>
                                        <Form.Control type="text" onChange={(e) => setCustomer(e.target.value)} value={customer} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Ordine</FormLabel>
                                        <Form.Control type="text" onChange={(e) => setOrder(e.target.value)} value={order} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Codice articolo</FormLabel>
                                        <Form.Control type="text" onChange={(e) => setCodeItem(e.target.value)} value={codeItem} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Descrizione articolo</FormLabel>
                                        <Form.Control type="text" onChange={(e) => setNameItem(e.target.value)} value={nameItem} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <hr />
                            <Row className='align-items-start mb-2'>
                                <Col md={4}>
                                    <FormLabel className='label_filters'>Intervallo date ordine</FormLabel>
                                    <InputGroup className="mt-2 mb-3">
                                        <Form.Control type="date" onChange={(e) => setDateOrderFrom(e.target.value)} value={dateOrderFrom} />
                                        <Form.Control type="date" onChange={(e) => setDateOrderTo(e.target.value)} value={dateOrderTo} />
                                    </InputGroup>
                                </Col>
                                <Col md={4}>
                                    <FormLabel className='label_filters'>Intervallo date consegna</FormLabel>
                                    <InputGroup className="mt-2 mb-3">
                                        <Form.Control type="date" onChange={(e) => setDateDeliveryFrom(e.target.value)} value={dateDeliveryFrom} />
                                        <Form.Control type="date" onChange={(e) => setDateDeliveryTo(e.target.value)} value={dateDeliveryTo} />
                                    </InputGroup>
                                </Col>
                            </Row>
                            <hr />
                            <Row className='align-items-start mb-2'>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Raggruppamento articolo</FormLabel>
                                        <Select className="basic-multi-select" isMulti onChange={handleFamily} classNamePrefix="select" defaultValue={""}
                                            isClearable={true} isSearchable={true} styles={colourStyles} options={familyList} ref={familyRef} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Magazzini</FormLabel>
                                        <Select className="basic-multi-select" isMulti onChange={handleWarehouse} classNamePrefix="select" defaultValue={""}
                                            isClearable={true} isSearchable={true} styles={colourStyles} options={warehouseList} ref={warehouseRef} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Brand</FormLabel>
                                        <Select className="basic-multi-select" isMulti onChange={handleBrand} classNamePrefix="select" defaultValue={""}
                                            isClearable={true} isSearchable={true} styles={colourStyles} options={brandList} ref={brandRef} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Incoterms</FormLabel>
                                        <Select className="basic-multi-select" isMulti onChange={handleIncoterms} classNamePrefix="select" defaultValue={""}
                                            isClearable={true} isSearchable={true} styles={colourStyles} options={incotermsList} ref={incotermsRef} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Gruppi di pagamento</FormLabel>
                                        <Select className="basic-multi-select" isMulti onChange={handlePayment} classNamePrefix="select" defaultValue={""}
                                            isClearable={true} isSearchable={true} styles={colourStyles} options={paymentList} ref={paymentRef} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Nazione anagrafica</FormLabel>
                                        <Select className="basic-multi-select" isMulti onChange={handleCountry} classNamePrefix="select" defaultValue={""}
                                            isClearable={true} isSearchable={true} styles={colourStyles} options={countryList} ref={countryRef} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='align-items-start mb-2'>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Agenti</FormLabel>
                                        <Select className="basic-multi-select" isMulti onChange={handleAgenti} classNamePrefix="select" defaultValue={""}
                                            isClearable={true} isSearchable={true} styles={colourStyles} options={agentList} ref={agentRef} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Gruppo di vendita</FormLabel>
                                        <Select className="basic-multi-select" isMulti onChange={handleSalesGroup} classNamePrefix="select" defaultValue={""}
                                            isClearable={true} isSearchable={true} styles={colourStyles} options={salesGroupList} ref={salesRef} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <hr />
                            <Row className='align-items-center mb-2'>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Righe</FormLabel>
                                        <Form.Select onChange={(e) => { setRighe(e.target.value) }} value={righe}>
                                            <option value="">Tutte</option>
                                            <option value="1">Complete</option>
                                            <option value="0">Da completare</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters mb-1'>Bindella</FormLabel>
                                        <Form.Select onChange={(e) => { setBindella(e.target.value) }} value={bindella}>
                                            <option value="">Tutti</option>
                                            <option value="1">SI</option>
                                            <option value="0">NO</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters mb-1'>Piano di carico</FormLabel>
                                        <Form.Select onChange={(e) => { setPdc(e.target.value) }} value={pdc}>
                                            <option value="">Tutti</option>
                                            <option value="1">SI</option>
                                            <option value="0">NO</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='mt-4'>
                                <div className='d-flex'>
                                    <Button variant='primary' className='me-3' onClick={() => Filter()}>Cerca</Button>
                                    <Button variant='outline-danger' onClick={() => reset()}>Reset filtri</Button>
                                </div>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey='2'>
                        <Accordion.Header>Valori e imballo</Accordion.Header>
                        <Accordion.Body>
                            <div className='mb-3'>
                                <Button variant='primary' size='sm' onClick={computeTotals}>Calcola totali</Button>{' '}
                                {!totalsComputed && <span className='text-muted'>Premi "Calcola totali" per aggiornare i valori</span>}
                            </div>
                            <Row>
                                <Col md={2}>
                                    <h5>Imballo</h5>
                                    <p>Colli: {packages !== null ? (parseFloat(packages) || 0).toFixed(2) : "0"}</p>
                                    <p>Peso: {weight !== null ? (parseFloat(weight) || 0).toFixed(2) : "0"}</p>
                                    <p>Volume: {volume !== null ? (parseFloat(volume) || 0).toFixed(2) : "0"}</p>
                                </Col>
                                <Col md={4}>
                                    <h5>Ordini</h5>
                                    <p>Totale: {totalOrder !== null ? (parseFloat(totalOrder) || 0).toFixed(2) : "0,00"}€</p>
                                    <p>Totale disponibili: {totalOrderDisp !== null ? (parseFloat(totalOrderDisp) || 0).toFixed(2) : "0,00"}€</p>
                                    <p>Totale non disponibili: {totalOrderNoDisp !== null ? (parseFloat(totalOrderNoDisp) || 0).toFixed(2) : "0,00"}€</p>
                                </Col>
                                <Col md={3}>
                                    <h5>Righe</h5>
                                    <p>Totale righe: {totalPrice !== null && totalPriceNoDisp !== null ? ((parseFloat(totalPrice) || 0) + (parseFloat(totalPriceNoDisp) || 0)).toFixed(2) : "0,00"}</p>
                                    <p>Totale disponibili: {totalPrice !== null ? (parseFloat(totalPrice) || 0).toFixed(2) : "0,00"}€</p>
                                    <p>Totale non disponibili: {totalPriceNoDisp !== null ? (parseFloat(totalPriceNoDisp) || 0).toFixed(2) : "0,00"}€</p>
                                    {/* <p>Totale parz. disponibili: €</p> */}
                                </Col>
                                <Col md={3}>
                                    <h5>Quantità</h5>
                                    <p>Quantità totale: {quantity !== null ? quantity : "0"}</p>
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Container>
        </>
    )
};
